<button *ngIf="(isCollectionAdmin() | async)" class="dropdown-item"
        [routerLink]="getBulkImportPageRouterLink()">
  {{'context-menu.actions.bulk-import.btn' | translate}}
</button>
